import { useMapGetter } from 'dashboard/composables/store';

// Inboxes can ask for the contact's CPF/CNPJ when an agent resolves a conversation.
export function useResolveCpfCnpj() {
  const getInbox = useMapGetter('inboxes/getInbox');

  const shouldAskCpfCnpj = conversation => {
    const inbox = getInbox.value(conversation?.inbox_id);
    return (
      Boolean(inbox?.ask_cpf_cnpj_on_resolve) &&
      !conversation?.meta?.sender?.cpf_cnpj
    );
  };

  return { shouldAskCpfCnpj };
}
